import { render, staticRenderFns } from "./OrdersBanner.vue?vue&type=template&id=11f7bfbe&"
import script from "./OrdersBanner.vue?vue&type=script&lang=js&"
export * from "./OrdersBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports